// Module
var code = `<form name="demographics" form-step-validity><demographics-form-section career-profile="careerProfile" gdpr-applies-to-user="gdprAppliesToUser"></demographics-form-section></form>`;
// Exports
export default code;